import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workDocsProjectDocumentsGrid: [],
    workDocsProjectDocumentsAll: [],
    workDocsProjectDocumentsShow: null,
    pageData: null,
    uploadDocumentsProgress: 0,
  },
  mutations: {
    setWorkDocsProjectDocumentsGrid(state, payload) {
      state.workDocsProjectDocumentsGrid = payload
    },
    setWorkDocsProjectDocumentsAll(state, payload) {
      state.workDocsProjectDocumentsAll = payload
    },
    setWorkDocsProjectDocumentsShow(state, payload) {
      state.workDocsProjectDocumentsShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setUploadDocumentsProgress(state, payload) {
      state.uploadDocumentsProgress = payload
    },
    setDefaultDocuments(state) {
      ;(state.workDocsProjectDocumentsGrid = []), (state.workDocsProjectDocumentsAll = [])
    },
  },
  getters: {
    workDocsProjectDocumentsGrid: (state) => {
      return state.workDocsProjectDocumentsGrid
    },
    workDocsProjectDocumentsAll: (state) => {
      return state.workDocsProjectDocumentsAll
    },
    workDocsProjectDocumentsShow: (state) => {
      return state.workDocsProjectDocumentsShow
    },
    pageData: (state) => {
      return state.pageData
    },
    uploadDocumentsProgress: (state) => {
      return state.uploadDocumentsProgress
    },
  },
  actions: {
    onWorkDocsProjectDocumentsGrid({ commit, rootState }, { limit, page }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/project-document/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&order[]=name:asc',
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsProjectDocumentsGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectDocumentsAll({ commit, rootState }, project_id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/project-document/grid?limit=0&filter[]=project_id:' +
            project_id +
            '&order[]=created_at:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsProjectDocumentsAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectDocumentsShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-document/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsProjectDocumentsShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectDocumentsCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-document',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectDocumentsUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-document',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectDocumentsDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-document/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsProjectDocumentsUploadFiles({ commit, rootState }, { data }) {
      return new Promise((resolve, reject) => {
        let progress = 0
        axios({
          url: rootState.apiDomain + '/api/uploadfile',
          data: data,
          method: 'POST',
          onUploadProgress: (e) => {
            progress = Math.round((e.loaded * 98) / e.total)
            commit('setUploadDocumentsProgress', progress)
          },
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
